import { axios, createFormData, handleError } from '../axios';

const AUTH_REQUEST_FAILED_MESSAGE = 'ارتباط با سرور برقرار نشد. دوباره تلاش کنید.';

export const adminAuth = (data) => {
  return new Promise((resolve) => {
    axios
      .post('admin/account/auth', createFormData(data ? data : {}))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
          resolve({
            status: 'error',
            auth: { value: false },
            message: AUTH_REQUEST_FAILED_MESSAGE,
          });
        }
      })
      .catch((e) => {
        handleError(e);
        resolve({
          status: 'error',
          auth: { value: false },
          message: e?.response?.data?.message || AUTH_REQUEST_FAILED_MESSAGE,
        });
      });
  });
};
